import { eq, has } from 'lodash';

export const capitalize = (str) => str[0].toUpperCase() + str.substr(1);

function accessor(data, field) {
  let value = data;

  if (typeof field === 'function') {
    value = field(data);
  }
  else if (data == null) {
    value = data;
  }
  else if (typeof field === 'string' && typeof data === 'object' && field in data) {
    value = data[field];
  }

  return value;
}

/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 */
function shallowEqual(objA, objB) {
  if (objA == null || objB == null) {
    return false;
  }

  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);

  const keyALength = keysA.length;

  if (keyALength !== keysB.length) {
    return false;
  }

  for (let i = 0; i < keyALength; i++) {
    if (!has(objB, keysA[i]) || !eq(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

function isShallowEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  if (typeof a !== 'object' && typeof b !== 'object') {
    return a === b;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  return shallowEqual(a, b);
}

export function dataValue(item, valueField) {
  return valueField && item && has(item, valueField)
    ? item[valueField]
    : item;
}

export function dataId(item, idField) {
  return idField && item && has(item, idField)
    ? item[idField]
    : null;
}

export function dataText(item, textField) {
  const value = accessor(item, textField);
  return value == null ? '' : value;
}

/**
 * I don't know that the shallow equal makes sense here but am too afraid to
 * remove it.
 */
export function valueMatcher(a, b, valueField) {
  return isShallowEqual(dataValue(a, valueField), dataValue(b, valueField));
}

export function dataIndexOf(data, item, valueField) {
  let idx = -1;
  const len = data.length;
  const isValueEqual = (datum) => valueMatcher(item, datum, valueField);

  while (++idx < len) {
    const datum = data[idx];

    if (datum === item || isValueEqual(datum)) {
      return idx;
    }
  }

  return -1;
}

export function dataItem(data, item, valueField) {
  const idx = dataIndexOf(data, dataValue(item, valueField), valueField);

  if (idx !== -1) {
    return data[idx];
  }

  return item;
}

export function splat(obj) {
  return obj == null ? [] : [].concat(obj);
}
